import { Box, Collapse, useTheme } from '@mui/material';

import { useEffect, useState } from 'react';
import { ANIMATION_DURATION_MS } from './LessonReportTemplateAddContainer';

type DisappearingRowPropsT = {
  height?: number;
};

function DisappearingRow({ height = 64 }: DisappearingRowPropsT) {
  const [open, setOpen] = useState(true);

  const { transitions } = useTheme();

  // mount → 바로 in=false로 바꿔서 "위로 줄어드는" 애니메이션만 수행
  useEffect(() => {
    // 다음 프레임에서 닫히게
    const id = requestAnimationFrame(() => setOpen(false));
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <Collapse
      in={open}
      appear={false}
      timeout={ANIMATION_DURATION_MS}
      easing={transitions.easing.easeOut}
    >
      <Box sx={{ height }} />
    </Collapse>
  );
}

export default DisappearingRow;
